import { useAuth } from '@hooks/useAuth'
import React from 'react'
import { Link } from 'react-router-dom'
import 'twin.macro'

const Home = () => {
  const { logout, user } = useAuth()

  console.log(user)

  return (
    <section className="w-500">
      <div className="flex justify-center w-full text-xl font-bold">홈화면</div>
      <div tw="flex flex-wrap gap-8 w-full justify-between mt-5">
        <Link to="/home/media/video">
          <button className="button base">비디오 등록 </button>
        </Link>
        <Link to="/home/media/file">
          <button className="button base">PDF 등록</button>
        </Link>
        <button className="button base">내정보 수정</button>
        <button className="button base" onClick={logout}>
          로그아웃
        </button>
        {user?.authorities.includes('ROLE_ADMIN') && (
          <Link to="/admin/user-management">
            <button className="button base">어드민 페이지</button>
          </Link>
        )}
      </div>
      <div className="flex justify-center w-full mt-8 text-xl font-bold">
        내정보
      </div>
      <div tw="mt-4 all:mt-2">
        <div>프로필 이미지</div>
        <img src={user?.profileUrl} />
        <div>아이디 : {user?.username}</div>
        <div>닉네임 : {user?.nickname}</div>
        <div>휴대폰 : {user?.phone}</div>
        <div>생년월일 : {user?.birth}</div>
        <div>성별 : {user?.gender}</div>
        <div>이메일 : {user?.email}</div>
      </div>
    </section>
  )
}

export default Home
